import { API_TENANT_SETTINGS } from "globals/constants";
import { request } from "utils/proxy";

/**
 * Tenant Settings Key response object.
 *
 * @typedef {Object} TenantSettingsKey
 *
 * @property {string} createUser - The user who created the setting. e.g.
 * @property {string} createDate - The date and time when the setting was created. "2024-05-09T10:48:50.390+0000"
 * @property {string} updateUser - The user who last updated the setting.
 * @property {string} updateDate - The date and time when the setting was last updated. e.g. "2024-05-09T10:48:50.390+0000"
 * @property {number} hibVersion - The hibernate version of the setting. e.g. 0
 * @property {string} id - The unique ID of the setting.
 * @property {string} tenantId - The ID of the tenant.
 * @property {string} key - The key of the setting. e.g. "FUNDING_PROGRAM"
 * @property {string} value - The value of the setting. e.g. "Funding Program"
 */

/**
 * A collection of functions for interacting with tenant settings.
 * @namespace
 */
export const tenantSettings = {
	/**
	 * Retrieve the label for the funding program.
	 *
	 * @param {object=} requestOptions - The request options.
	 *
	 * @return {Promise<TenantSettingsKey>}
	 */
	getFundingProgramLabel: requestOptions => request(`${API_TENANT_SETTINGS}/key/FUNDING_PROGRAM`, requestOptions),
};
